<!--
 * @Author: your name
 * @Date: 2020-11-17 15:18:08
 * @LastEditTime: 2021-08-26 13:44:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\partners.vue
-->
<template>
<div class="partners">
     <div class="type-page">
        <h1>{{ typeStr == 'org' ? '合作单位': typeStr == 'class' ? '合作院校': ''}} <br /><span>{{ typeStr == 'org' ? 'Cooperation': 'Partner Schools' }}</span></h1>
        <ul class="clearfix mt25">
            <li
                v-for="orgItem of List"
                :key="orgItem.id"
                 @click="openLink(orgItem.url)"
            >
                <img :src="orgItem.image" alt="">
            </li>
        </ul>
        <div class="down" v-if="partnersList.length > 14"><img src="./../../assets/image/Down.png" alt="" @click="more" :class="{rotate : isrotate}"></div>
        
  </div>
</div>
 
</template>

<script>
export default {
    props: ['partnersList', 'type'] ,
    data(){
        return {
            List: [],
            isrotate: false,
            typeStr: null
        }
    },
    watch: {
        partnersList(newVal, oldVal){
            if(newVal.length > 14){
                this.List = newVal.slice(0,15)
            } else {
                this.List = newVal
            }
        },
        type:{
            handler(newVal, oldVal) {
            this.typeStr = newVal
            },
            immediate: true
        }
    },
    methods: {
         openLink(url){
            window.open(url,'_blank')
        },
        more(){
            if(this.isrotate){
                this.isrotate = false
                this.List = this.List.slice(0,15)
            }else{
                this.List = this.partnersList
                this.isrotate = true
            }
        }
    }
}
</script>

<style scoped lang="scss">
.partners {
    // background: #fff;
}
.type-page {
    padding: 80px 0;
}
    h1 { 
        font-size: 18px;
        font-weight: 600;
        color: #2B2F37;
        text-align: center;
        span {
            color: #999 !important;
            font-weight: 500;
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 1px;
        }
    }
   .type-page ul {
       overflow: hidden;
    }
   .type-page li {
        width: 17.5%;
        float: left;
        margin: 15px 15px 0 ;
        img {
            width: 100%;
            height: 64px;
        }
    }
    .down {
        margin-top: 50px;
        text-align: center;
        .rotate {
            transform:rotate(180deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/index/partners.vue